module.exports = __webpack_public_path__ + "img/mC-growth-rule.fc3ab79e.png";